import React from "react";
import { BaseBox, BaseTypography } from "../exports";

function BaseCheckbox({ label, checked, onChange, sx = {} }) {
  return (
    <BaseBox
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
        ...sx,
      }}
      onClick={() => onChange(!checked)}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        onClick={(e) => e.stopPropagation()}
        style={{ cursor: "pointer" }}
      />
      {label && (
        <BaseTypography sx={{ fontSize: "0.95rem", userSelect: "none" }}>
          {label}
        </BaseTypography>
      )}
    </BaseBox>
  );
}

export default BaseCheckbox;
